import { create } from 'zustand';
import { GeneralConfig } from '../config/generalConfig';
import { formatDateAndTime, formatDateOnly } from '../utils/dateUtils';
import { useLanguageStore } from './languageStore';

interface DateFormatStore {
  format: string;
  formatDate: (date: Date) => string;
  formatDateTime: (date: Date) => string;
}

interface DateFormatActions {
  setFormat: (dateFormat: string) => void;
}

export const useDateFormatStore = create<DateFormatStore & DateFormatActions>(
  (set, get) => ({
    format: GeneralConfig.dateFormat,
    setFormat: (dateFormat: string) => set({ format: dateFormat }),
    formatDate: (date: Date) => {
      const { format } = get();
      const { language } = useLanguageStore.getState();
      return formatDateOnly(date, format, language);
    },
    formatDateTime: (date: Date) => {
      const { format } = get();
      const { language } = useLanguageStore.getState();
      return formatDateAndTime(date, format, language);
    },
  })
);
